import dynamic from 'next/dynamic'

import Link from 'components/Link'
import useHeaderState from 'hooks/useHeaderState'

import s from './HardcodedFlashMessage.module.css'
import isModellinkSite from '../../helpers/isModellinkSite'
import { parseCookies } from 'nookies'
import { useAtom } from 'jotai'
import { currentSiteAtom } from '../../lib/atoms'

function HardcodedFlashMessage() {
  const [currentSite] = useAtom(currentSiteAtom)
  const { clearFlashMessage } = useHeaderState()

  const show = showFlashMessage()
  const businessName = isModellinkSite()
    ? 'Modellink'
    : 'Select Model Management'

  return (
    <div>
      {show && (
        <div>
          <div className={s.overlay}></div>
          <div className={s.popup}>
            <h3>Important Notice</h3>
            <p>
              Please be aware that individuals are falsely claiming to work for{' '}
              {businessName} (and they have been using some of our staff names
              and e-mail signatures).
            </p>
            <p>
              If you are contacted by anyone claiming to represent us, please do
              not respond without first verifying their identity by promptly
              calling directly at one of our offices.
            </p>

            <div className={s.buttons}>
              {currentSite && (
                <Link
                  type="Page"
                  className={s.infoButton}
                  href="beware-of-scammers"
                >
                  Find out more
                </Link>
              )}
              <button
                type="button"
                title="Close overlay"
                className={s.continueButton}
                onClick={clearFlashMessage}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

function showFlashMessage() {
  const cookies = parseCookies()

  if (!cookies['flash-message-read']) {
    return true
  }
  return true
}

export default dynamic(() => Promise.resolve(HardcodedFlashMessage), {
  ssr: false,
})
